import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import * as typography from '../../styles/typography';
import { unit } from '../../styles/unit';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-4fzplp-0"
})(["", ";padding:", " ", ";"], typography.body2, unit(3), unit(4));
const CardContent = /*#__PURE__*/forwardRef(function CardContent({
  children
}, forwardedRef) {
  return /*#__PURE__*/_jsx(Container, {
    ref: forwardedRef,
    children: children
  });
});
CardContent.propTypes = {
  children: T.node.isRequired
};
export { CardContent };